export default __webpack_public_path__ + "static/media/Hurray_image.7316020a.png";